<template>
  <div class="container">
    <div class="body">
      <!-- 公司简介 -->
      <div class="title">{{ toplist.title }}</div>
      <div class="before_info">
        <p>{{ toplist.info }}</p>
      </div>
      <div v-for="item in duihualist" :key="item.id">
        <div class="title">{{ item.title }}</div>
        <div
          class="content"
          v-for="(subItem, index) in item.children"
          :key="index"
        >
          <a :href="subItem.linkto" class="custom-link" target="_blank">
            <div class="info">
              <div class="left">
                <p class="ingo_title">{{ subItem.shorttitle }}</p>
                <p class="info_content">{{ subItem.shortinfo }}</p>
              </div>
              <div class="right">
                <img :src="subItem.pic" alt="" class="info_img" />
              </div>
            </div>
          </a>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import axios from 'axios'
import wx from 'weixin-js-sdk'
import { getWechatShare, getWechatShareContent } from '../../../api/share.js'
import { Toast } from 'mint-ui'
// import wx from 'weixin-js-sdk'
// Toast('分享成功')11
export default {
  data () {
    return {
      toplist: {},
      duihualist: [],
      appData:{
        appId:'',
        timestamp:null,//时间戳
        signature:'',//签名
        nonceStr:'',//随机字符串
      },
      result:{
        desc:'',//内容
        imgUrl:'',//图片地址
        title:'',//分享标题
        link:'',//分享链接
      },
    }
  },
  components: {
    // SpecialIndex
  },
  created() {
    
    this.getlist()
  },
  mounted(){
    this.handleShare()
  },
  methods: {
    getlist () {
      let that = this
      const apiUrl = env.API_HOST + '/Padindex/about_jiazi'
      axios
        .get(apiUrl)
        .then(response => {
          let res = response.data.result
          that.toplist = res.toplist
          that.duihualist = res.duihualist
        })
        .catch(error => {
          console.error('请求失败:', error)
        })
    },
    handleShare () {
      let url = ''
				if (window.location.href.indexOf('#') > -1) {
					url = window.location.href.split('#')[0]
				} else {
					url = window.location.href
				}
				getWechatShare({url}).then(res => {
          this.appData=res.result.signPackage
					getWechatShareContent({ type: 'index' }).then(ress => {
            this.result=ress.result
            console.log(this.result,'result');
            console.log(this.appData,'appid');
						     wx.config({
                      debug: false, // 开启调试模式
                      appId: this.appData.appId,
                      timestamp: parseInt(this.appData.timestamp),
                      nonceStr: this.appData.nonceStr,
                      signature: this.appData.signature,
                      jsApiList: ['onMenuShareTimeline','onMenuShareAppMessage','updateAppMessageShareData']
                  });
                  wx.ready(function () {
                    //  设置分享给好友的内容
                              wx.onMenuShareAppMessage({
                                  title: this.result.title,
                                  desc: this.result.desc,
                                  link: this.result.link,
                                  imgUrl: this.result.imgUrl,
                                  success: function() {
                                      // 设置成功后的回调
                                      console.log('分享给好友成功');
                                      alert('分享给好友成功')
                                  },
                                  fail: function() {
                                      // 设置失败后的回调
                                      alert('分享给好友失败');
                                  }
                              });
                              // 设置分享到朋友圈的内容
                              wx.onMenuShareTimeline({
                                  title: this.result.title,
                                  link: this.result.link,
                                  imgUrl: this.result.imgUrl,
                                  success: function() {
                                      // 设置成功后的回调
                                      alert('分享到朋友圈成功');
                                  },
                                  fail: function() {
                                      // 设置失败后的回调
                                      alert('分享到朋友圈失败');
                                  }
                              });
                  })

					}).catch(function(error) {
						Toast(error.message)
					})
				}).catch(function(error) {
					Toast(error.message)
				})
			
    },
  }
}
</script>
<style lang="scss" scoped>
.container {
  background-color: #fff;
  .body {
    padding: 10px 15px;
    box-sizing: border-box;
  }
  .title {
    margin: 10px 0;
    text-align: center;
    font-weight: 700;
  }
  .before_info {
    line-height: 1.2rem;
    text-indent: 2em;
    font-size: 0.8rem;
  }
  .content {
    // background-color: #f8f6f6;
    .custom-link {
      text-decoration: none; /* 去掉下划线 */
      color: inherit; /* 继承父元素的颜色 */
    }
    .info {
      padding: 5px;
      margin-bottom: 8px;
      box-sizing: border-box;
      border: 1px solid #d8d6d6;
      border-radius: 10px;
      display: flex;
      height: 5rem;
      background-color: #fff;
      .right {
        width: 7.5rem;
        height: 100%;
        .info_img {
          border-radius: 10px;
          width: 100%;
          height: 100%;
        }
      }
      .left {
        flex: 1;
        height: 100%;
        padding-right: 3px;
        box-sizing: border-box;
        .ingo_title {
          font-size: 0.7rem;
          color: #000;
          height: 2rem;
          display: -webkit-box;
          -webkit-line-clamp: 2;
          -webkit-box-orient: vertical;
          overflow: hidden;
        }
        .info_content {
          margin-top: 5px;
          overflow: hidden;
          font-size: 0.7rem;
          color: #999;
          height: 2rem;
          display: -webkit-box;
          -webkit-line-clamp: 2;
          -webkit-box-orient: vertical;
          overflow: hidden;
        }
      }
    }
  }
}
</style>
